import React, {useEffect, useState} from "react";
import {ModalProps} from "antd/lib/modal";
import {Modal, Upload} from "antd";
import {InboxOutlined} from "@ant-design/icons";
import {RcFile} from "antd/lib/upload/interface";

interface UploadModalProps extends ModalProps {
    onUpload: (file: File) => void
    template?: string
    onTemplateExport?: () => void
}

function UploadModal(props: UploadModalProps) {
    const {onUpload, template, onTemplateExport, ...otherProps} = props
    const [file, setFile] = useState<RcFile[]>([])

    useEffect(() => {
        if (otherProps.visible) {
            setFile([])
        }
    }, [otherProps.visible])

    function beforeUpload(file: RcFile) {
        setFile([file])
        return false
    }

    function onOk() {
        if (file.length > 0 && onUpload) {
            onUpload(file[0])
        }
    }

    return (
        <Modal {...otherProps} onOk={onOk}>
            <Upload.Dragger beforeUpload={beforeUpload} fileList={file}>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined/>
                    <p className="ant-upload-text">Click or drop file to here</p>
                    {onTemplateExport ? (
                        <a className="ant-upload-text" onClick={event => {
                            event.stopPropagation()
                            onTemplateExport()
                        }}>
                            Import Template
                        </a>
                    ) : template && (
                        <a className="ant-upload-text" href={template} target={'_blank'}
                           onClick={event => event.stopPropagation()}>
                            Import Template
                        </a>
                    )}
                </p>
            </Upload.Dragger>
        </Modal>
    )
}

export default UploadModal
